import { useEffect, useState } from "react";
import SettingLayout from "../SettingLayout";
import "../../../../styles/dashboard/setting/SettingLayout.css";
import {
  RazorImageFallback,
  RazorInputField,
  toast,
} from "../../../../components/razor-reuse";
import { ALL_ICONS } from "../../../../assets/icons/AllIcons";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import {
  capitalizeFirstLetter,
  objectToFormData,
  reactSelectStyleTable,
} from "../../../../utils/Helper";
import { updateUserProfile } from "../../../../redux/settings";
import { getLoggedInUser } from "../../../../redux/userAuth";

const ProfileIndex = () => {
  const { loading, user, loading_user } = useSelector(
    (state: RootState) => state.auth
  );
  const dispatch = useDispatch();
  const { loadingDelete } = useSelector((state: RootState) => state.settings);
  type detailProps = {
    profile_photo: any;
    first_name: string;
    last_name: string;
    gender: any;
    email: string;
    about_me: string;
  };

  const [details, setDetails] = useState<detailProps>({
    profile_photo: "",
    first_name: "",
    last_name: "",
    gender: "",
    email: "",
    about_me: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const removeSeparator = (list?: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return {
          label: capitalizeFirstLetter(chi?.replaceAll("_", " ")),
          value: chi,
        };
      });

      return newList;
    }
  };

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  useEffect(() => {
    if (Object?.keys(user)?.length > 0) {
      setDetails((prev) => {
        return {
          ...prev,
          first_name: user?.first_name,
          email: user?.email,
          last_name: user?.last_name,
          about_me: user?.about_me,
          gender: { label: user?.gender, value: user?.gender },
        };
      });
    }
  }, [user]);

  const isTextValid = (name: string) => /^[A-Za-z\s'-]+$/.test(name); // letters, spaces, apostrophes, hyphens

  const handleDisable = () => {
    const val =
      details?.about_me === user?.about_me &&
      details?.first_name === user?.first_name &&
      details?.last_name === user?.last_name &&
      details?.gender?.label === user?.gender &&
      !details?.profile_photo;

    // Overall form validity
    const isFormValid =
      isTextValid(details?.first_name) && isTextValid(details?.last_name);
    return val || !isFormValid;
  };

  const handleSubmit = async () => {
    const obj = {
      profile_picture: details?.profile_photo,
      last_name: details?.last_name,
      first_name: details?.first_name,
      gender: details?.gender?.label,
      about_me: details?.about_me,
    };
    const data = await dispatch(
      updateUserProfile(objectToFormData(obj)) as any
    );

    if (data?.payload?.data?.status) {
      setDetails({
        profile_photo: "",
        first_name: "",
        last_name: "",
        gender: "",
        email: "",
        about_me: "",
      });
      dispatch(getLoggedInUser({}) as any);
    }
  };

  return (
    <>
      <SettingLayout
        hideBtnIcon
        btnDisable={handleDisable()}
        btnLabel="Save Changes"
        title="Admin Profile"
        onBtnClick={handleSubmit}
        btnLoading={loadingDelete}
        pageLoading={Object?.keys(user)?.length < 1 && loading_user}
      >
        <div
          onClick={() => {
            console.log(user);
          }}
          className="profile-admin-settings-wrap-index"
        >
          <p className="label-text">Profile Photo</p>
          {/* profile image box start */}
          <div className="profile-photo-bow-wrap">
            <input
              type="file"
              name="profile-upload-input"
              id="profile-upload-input"
              className="input-upload"
              accept=".jpeg, .jpg, .png"
              onChange={(e: any) => {
                if (e?.target?.files[0]) {
                  const maxFileSize = 2 * 1024 * 1024;
                  const fileSize = e?.target?.files[0]?.size;
                  if (fileSize > maxFileSize) {
                    toast.error("File size shot not exceed 2mb");
                  } else {
                    setDetails((prev) => {
                      return { ...prev, profile_photo: e?.target?.files[0] };
                    });
                  }
                }
              }}
            />
            <div className="img-show-label-box">
              <RazorImageFallback
                url={
                  details?.profile_photo
                    ? URL.createObjectURL(details?.profile_photo)
                    : user?.profile_image
                }
                className="display-img"
              >
                <div className="default-img">
                  <figure className="img-box">
                    {ALL_ICONS?.unknown_img()}
                  </figure>
                </div>
              </RazorImageFallback>
              <label htmlFor="profile-upload-input" className="input-label">
                <div className="icon-wrap">
                  <figure className="img-box">
                    {ALL_ICONS?.edit_profile("#ffffff")}
                  </figure>
                </div>
              </label>
            </div>
            <p className="img-size-note">
              Only standard format are allowed Png. Jpeg. files no more than 2mb
            </p>
          </div>
          {/* profile image box end */}
          <p className="label-text">Profile Information</p>
          {/* personal infor wrap start */}
          <div className="personal-information-box-wrap">
            {/* two groups start */}
            <div className="two-group-box">
              <RazorInputField
                color="black-light"
                type="text"
                placeholder=" "
                label="First Name"
                value={details?.first_name}
                onChange={handleChange}
                name="first_name"
              />
              <RazorInputField
                color="black-light"
                type="text"
                placeholder=" "
                label="Last Name"
                value={details?.last_name}
                onChange={handleChange}
                name="last_name"
              />
              <RazorInputField
                color="black-light"
                type="email"
                placeholder=" "
                label="Email"
                disabled
                value={details?.email}
                onChange={handleChange}
                name="email"
              />
              <RazorInputField
                color="black-light"
                type="select"
                placeholder=" "
                label="Gender"
                value={details?.gender}
                onChange={(e: any) => {
                  setDetails((prev) => {
                    return { ...prev, gender: e };
                  });
                }}
                name="gender"
                selectOption={genderOptions}
                selectStyles={reactSelectStyleTable}
              />
              <RazorInputField
                color="black-light"
                type="select"
                placeholder=" "
                label="Role"
                // disabled
                multi
                value={removeSeparator(user?.roles)}
                style={{ gridColumn: `1 / span 2` }}
                disabled
              />
              <RazorInputField
                color="black-light"
                type="textarea"
                placeholder=" "
                label="About Me"
                value={details?.about_me}
                onChange={handleChange}
                name="about_me"
              />
            </div>
            {/* two groups end */}
          </div>
          {/* personal infor wrap end */}
        </div>
      </SettingLayout>
    </>
  );
};

export default ProfileIndex;
